

export default {
  props: {
    redsysData: {
      type: Object,
      required: true
    },
  },
  data: () => ({
  })
};
